import * as React from "react";
import { observer } from "mobx-react";
import { HotelWizardStateProps } from "../typings";

export const HotelHiddenSearchData = observer((props: HotelWizardStateProps) => {
  const {
    isAddACarChecked,
    isAddAFlightChecked,
    hotelPackageType,
    hotelTabSelected,
    sourceIdSelected,
    latLong,
  } = props.hotelWizardState;

  return (
    <>
      {(isAddAFlightChecked || isAddACarChecked) && (
        <input type="hidden" name="packageType" data-testid="package-type" value={hotelPackageType} />
      )}
      {!hotelTabSelected && <input type="hidden" name="sort" data-testid="vr-sort" value="vacationRental" />}
      {sourceIdSelected && <input type="hidden" name="selected" data-testid="source-id" value={sourceIdSelected} />}
      {latLong && <input type="hidden" name="latLong" data-testid="lat-long" value={latLong} />}
    </>
  );
});
